import { useRef, useState } from "react";
import styled from "styled-components";
import BoldBlue from "./BoldBlue";
import { useTranslation } from "react-i18next";
import Popup from "./Popup";
import H2 from "./H2";
import Select from "./Select";
import BlueButton from "./BlueButton";
import BlueOnBlueLabel from "./BlueOnBlueLabel";
import { useEffect } from "react";

const Container = styled.div`
    display: inline-block;

    .labels {
        margin: 10px 10px 0 0;
        padding: 10px 15px;
        border-radius: 5px;
        display: inline-flex;
        align-items: center;

        img {
            width: 10px;
            margin: 0 0 0 10px;
            cursor: pointer;
        }
    }

    .addbutton {
        background-color: #eee;

        img {
            margin: 0 10px 0 0;
        }

        &:hover {
            background-color: #ddd;
        }
    }
`;

const Top = styled.div`
    width: 100%;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
`;

const MultiSelector = (props) => {
    const [currentValue, setCurrentValue] = useState(props.defaultValue || "");
    const [popupOpen, setPopupOpen] = useState(false);
    const { i18n } = useTranslation('common');

    const valuesListing = props.valuesListing

    useEffect(() => {
        if(props.defaultValue) setCurrentValue(props.defaultValue);
    }, [props.defaultValue]);

    useEffect(() => {
        if(props.onChange) props.onChange(currentValue);
    }, [currentValue, props]);

    const selectRef = useRef();

    function addValuee(e) {
        e.preventDefault();
        if(!selectRef.current.value) return;
        const _currentValues = currentValue.split(";");
        _currentValues.push(selectRef.current.value);
        setCurrentValue(_currentValues.join(";"));
        setPopupOpen(false);
    }

    function removeValue(_value) {
        const _currentValues = currentValue.split(";");
        _currentValues.splice(_currentValues.indexOf(_value),1);
        setCurrentValue(_currentValues.join(";"));
    }

    const valueCodeToString = (value, lang) => {
        if(!value) return null;
        const valueObject = valuesListing.find(_value => _value.code === value);
        if(!valueObject) return null;
        return lang === "fr" ? valueObject.fr : valueObject.en;
    }
    const valuesAsAnArray = currentValue.split(";").map((_value) => valueCodeToString(_value, i18n.language)).filter(_value => _value);

    const label = props.label

    return (
        <Container style={props.style}>
            <Top>
                <BoldBlue>{label}</BoldBlue>
            </Top>
            {valuesAsAnArray.map((_value) => 
                <BlueOnBlueLabel className="labels" key={_value}>
                    {_value}
                    <img alt={i18n.language === "fr" ? "Supprimer" : "Remove"} title={i18n.language === "fr" ? "Supprimer" : "Remove"}  src="/img/x_bleu.png" onClick={() => removeValue(_value)}/>
                </BlueOnBlueLabel>
            )}
            {/* if the number of values in the array is less than the number of values in the listing, display the '+ add' button */}
            {valuesAsAnArray.length < valuesListing.length &&
                <BlueOnBlueLabel className="labels addbutton" style={{cursor:"pointer"}} onClick={() => setPopupOpen(true)}>
                    <img src='/img/croix_bleue.png' alt={i18n.language === "fr" ? "Ajouter" : "Add"} />
                    {i18n.language === "fr" ? "Ajouter" : "Add"}
                </BlueOnBlueLabel>
            }
            <input readOnly name={props.name} hidden value={currentValue} />
            {popupOpen && <Popup close={() => setPopupOpen(false)}>
                <H2>{label}</H2><br/>
                <Select style={{width:"100%"}} ref={selectRef}>
                    {valuesListing.filter(c => !valuesAsAnArray.find(val => val === c.code)).map((_value) =>
                        <option key={_value.code} value={_value.code}>{i18n.language === "fr" ? _value.fr : _value.en}</option>
                    )}
                </Select><br/>
                <BlueButton onClick={addValuee}>{i18n.language === "fr" ? "Ajouter" : "Add"}</BlueButton>
            </Popup>}
        </Container>
    );
}

export default MultiSelector;